import Emitter from "es6-event-emitter";

export default class OneTrust extends Emitter {
  constructor(options) {
    super();
    this._options = options;
    window.addEventListener("cmpUpdated", () => {
      this.trigger("userConsent:changed");
    });
    this._injectScript();
  }

  _injectScript() {
    let script = document.createElement("script");
    script.type = "text/javascript";
    script.src = "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js";
    const dataDomainScriptId =
      process.env.ENV === "production"
        ? "d26e3494-83e4-4d57-9225-1d7f6dfec358"
        : "d26e3494-83e4-4d57-9225-1d7f6dfec358-test";
    script.setAttribute("data-domain-script", dataDomainScriptId);

    let callbackscript = document.createElement("script");
    callbackscript.type = "text/javascript";
    // Callback funtion is used to notify app that OneTrust is initialised
    callbackscript.text = `function OptanonWrapper() {window.dispatchEvent(new Event("cmpUpdated"));}`;

    document.head.appendChild(script);
    document.head.appendChild(callbackscript);
  }

  // Method is used in ER script, needs to exist on cmpManager object
  isERTrackingEnabled() {
    if (this._options.features.ER)
      return this.getConsentForCookieGroup(this._options.ER.categoryId);
  }

  isSocialSharingTrackingEnabled() {
    if (this._options.features.socialSharing) {
      return this.getConsentForCookieGroup(
        this._options.socialSharing.categoryId
      );
    } else {
      return true;
    }
  }

  getConsentForCookieGroup(consentGroup) {
    return window.OnetrustActiveGroups.includes(consentGroup);
  }

  showPreference() {
    window.OneTrust.ToggleInfoDisplay();
  }
}



// WEBPACK FOOTER //
// ./src/common/cmp/oneTrust.js